const redirect = (url: string, location: Location = window.location): void =>
  location.assign(url);

export default redirect;
